import { useMemo } from 'react';

export const useExtractIdFromKey = (key: string) => useMemo(() => key.split('_')[1] ?? key, [key]);
